import React from 'react';

export function lazyImportSvg(importFn: () => Promise<typeof import('*.svg')>) {
  return React.lazy(() => importFn());
}
